import script from "./MConference.vue?vue&type=script&setup=true&lang=js"
export * from "./MConference.vue?vue&type=script&setup=true&lang=js"

import "./MConference.vue?vue&type=style&index=0&id=28c441de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c441de"]])

export default __exports__